const ISO_DATE_PREFIX = /^\d{4}-\d{2}-\d{2}(?:T|$)/

export function toSchemaDatePublished(value: unknown): string | undefined {
  if (typeof value !== "string" || !ISO_DATE_PREFIX.test(value)) {
    return undefined
  }

  if (!Number.isFinite(Date.parse(value))) {
    return undefined
  }

  const date = value.slice(0, 10)
  // Validate the source calendar day without shifting it across time zones.
  const roundTrip = new Date(`${date}T00:00:00.000Z`).toISOString().slice(0, 10)

  return roundTrip === date ? date : undefined
}
